import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert, RadioSelect } from '../index.js';
import { PlaceholderLoader } from '../index.js';
import TabComponent, { Tab } from './TabComponent.js';
const CollectorInfo = (props) => {
    const { id } = props;
    const lang = useSelector((s) => s.lang);
    const collectorLoadable = useCollector(id);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const [tab, setTab] = useState(Tab.MASTER);
    return (React.createElement("div", null, collector ? (React.createElement("div", null,
        React.createElement("h1", null, collector.name),
        collector.collectorId === '63be758c-cff9-4c29-8645-17759c99c6b4' ? (React.createElement(Alert, { message: "Please refrain from modifying this collector, as it is actively used for billing Debbie's customers." })) : null,
        React.createElement(RadioSelect, { active: tab === Tab.MASTER, label: lang.collectors.masterData, onClick: () => setTab(Tab.MASTER) }),
        React.createElement(RadioSelect, { active: tab === Tab.LAYOUT, label: lang.collectors.layout, onClick: () => setTab(Tab.LAYOUT) }),
        React.createElement(RadioSelect, { active: tab === Tab.WEBSITES, label: lang.collectors.websites, onClick: () => setTab(Tab.WEBSITES) }),
        React.createElement(RadioSelect, { active: tab === Tab.LEGAL, label: lang.collectors.legal, onClick: () => setTab(Tab.LEGAL) }),
        React.createElement(RadioSelect, { active: tab === Tab.PAYMENT_OPTIONS, label: lang.collectors.paymentOptions, onClick: () => setTab(Tab.PAYMENT_OPTIONS) }),
        me && exclusiveContent?.includes(me.id) && (React.createElement(RadioSelect, { active: tab === Tab.COMMUNICATION_CHANNELS, label: lang.collectors.communicationChannels, onClick: () => setTab(Tab.COMMUNICATION_CHANNELS) })),
        React.createElement(TabComponent, { tab: tab, collector: collector, lang: lang }))) : (React.createElement(PlaceholderLoader, null))));
};
export default CollectorInfo;
//# sourceMappingURL=CollectorInfo.js.map